import { render } from "./TotalAnualCobrancaView.vue?vue&type=template&id=50c189e8&scoped=true"
import script from "./TotalAnualCobrancaView.vue?vue&type=script&lang=js"
export * from "./TotalAnualCobrancaView.vue?vue&type=script&lang=js"

import "./TotalAnualCobrancaView.vue?vue&type=style&index=0&id=50c189e8&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c189e8"]])

export default __exports__